import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import {
  Breadcrumbs,
  Grid,
  Typography,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPictreeDataReportByUser,
} from "actions";
import * as C from "components";
import ReportRanking from "components/PicTree/Report/ReportRanking";
import CalendarRangePicker from "components/Calendar/CalendarRangePicker";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";
import CalendarRangePicTreeNttFt from "components/Calendar/CalendarRangePicTreeNttFt";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReportCountByUsers = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  dateRangePicTreeNtt,
  dateRangePicTreeNttFt,
  selectedSeason,
  selectedSeasonNtt,
  selectedSeasonNttFt,
  getPictreeDataReportByUser,
  reportByUser,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const pathname = location.pathname;
  const [initialDataCall, setInitialDataCall] = useState(true);

  const getCompanyFromPath = (pathname) => {
    const segments = pathname.split("/").filter(Boolean);
    const pictreeIndex = segments.indexOf("pictree");
    if (pictreeIndex === -1) {
      return undefined;
    }
    return segments[pictreeIndex + 1];
  };

  useEffect(() => {
    setCurrentPage(pathname);
    setInitialDataCall(true);
  }, [pathname, setCurrentPage]);

  const company = getCompanyFromPath(pathname);
  const currentDateRange = company === "ntt"
    ? dateRangePicTreeNtt
    : company === "ntt-ft"
      ? dateRangePicTreeNttFt
      : dateRangePicTree;
  const currentSelectedSeason = company === "ntt"
    ? selectedSeasonNtt
    : company === "ntt-ft"
      ? selectedSeasonNttFt
      : selectedSeason;

  useEffect(() => {
    if (
      currentDateRange[0] !== null &&
      currentDateRange[1] !== null &&
      currentSelectedSeason.length > 0 &&
      initialDataCall
    ) {
      getPictreeDataReportByUser(company);
      setInitialDataCall(false);
    }
  }, [company, currentDateRange, currentSelectedSeason, initialDataCall, getPictreeDataReportByUser]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée {company.toUpperCase().replace("-", " ")}</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">報告モード</Typography>
              <Typography variant="body1">ユーザー別報告件数</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            {company === "ntt" ? (
              <CalendarRangePicTreeNtt mDate={"2024/12/07"} page="pictree" pictree />
            ) : company === "ntt-ft" ? (
              <CalendarRangePicTreeNttFt mDate={"2026/01/31"} page="pictree" pictree />
            ) : (
              <CalendarRangePicker mDate={"2024/04/13"} page="pictree" pictree />
            )}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="center"
        >
          <Grid item xs={12} md={12} lg={10} style={{ marginTop: 0, justifyContent: "center" }}>
            <ReportRanking reportByUser={reportByUser} />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReportCountByUsers.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  dateRangePicTreeNttFt: state.page.dateRangePicTreeNttFt,
  selectedSeason: state.pictree.selectedSeason,
  selectedSeasonNtt: state.pictreeNtt.selectedSeason,
  selectedSeasonNttFt: state.pictreeNttFt.selectedSeason,
  reportByUser: state.pictree.reportByUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreeDataReportByUser: (param) => dispatch(getPictreeDataReportByUser(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReportCountByUsers));
